(function() {

  'use strict';

	 function RdStation() {

			var RdStation = {};

			RdStation.PostToRdStation = function(obj) {
				var dataArray = _.map(obj, function(value, key) {
					return {name : key, value: value };
				})
				RdIntegration.post(dataArray, function () { console.log('callback'); });
			};         

			return RdStation;

	  };

  angular
    .module('mandaeApp')
    .factory('RdStation', RdStation);

}());

